/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Provider } from "~/generated/graphql";
import { useEstateRecords } from "~/hooks";
import { isCloudResource, noop } from "~/tools";
import { ProviderSpecificDetails } from "../types";

export function useEstateNidsByProviderDetails(
  provider: Provider,
  details: ProviderSpecificDetails[]
): { [providerId: string]: string } {
  const providerIDs = [...new Set(details.map(({ providerId }) => providerId))];

  const { data: searchResult } = useEstateRecords(
    {
      variables: {
        limit: providerIDs.length,
        filter: {
          provider: [provider],
          providerId: providerIDs,
          typeSubtype: [
            ...new Set(details.map(({ typeSubtype }) => typeSubtype)),
          ],
        },
      },
    },
    noop
  );

  const records = searchResult?.resources ?? [];
  return Object.fromEntries(
    records
      .filter(isCloudResource)
      .filter((r) => providerIDs.includes(r.name))
      .map((r) => [r.name, r.id])
  );
}
